import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'angular2-useful-swiper';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/_service/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import { ConfirmModalComponent } from 'src/@common/confirm-modal/confirm-modal.component';
import {MatDialog } from '@angular/material';

@Component({
  selector: 'app-meeting-modal',
  templateUrl: './meeting-modal.component.html',
  styleUrls: ['./meeting-modal.component.scss']
})
export class MeetingModalComponent implements OnInit {
  public configure: PerfectScrollbarConfigInterface = {};
  @ViewChild('usefulSwiper', { static: false }) usefulSwiper: SwiperComponent;
  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30,
    initialSlide: 0,
  };
  meetingArr: any[] = [];
  dataList: any[] = [];
  meetingAttachedwith: any;
  meetingrelatedtask: any;
  user: any = {
    IsApproved: 'Approve',
    ActiveStatus: true
  };
  isMoreUser = 2;
  meetingUser: any;
  confirmDialog: MatDialogRef<ConfirmModalComponent>;

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<MeetingModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.meetingArr = data.detailList;
    this.config.initialSlide = data.activeIndex;

    console.log("data comp",data)
    console.log("data",data.action)

    if (data.action === "meetingAttachedwith") {
      this.meetingAttachedwith = data.action;
    }
    if (data.action === "meetingrelatedtask") {
      this.meetingrelatedtask = data.action;
    }
    if(data.action=='meetingtopopup'){
      this.meetingUser=data.data;
    }

  }
  ngOnInit() {

  }

  meetingList() {
    this.spinner.show();
    this.appService.postService({}, 'MeetingList')
      .subscribe(response => {
        this.meetingArr = response.body.Result;
        this.spinner.hide();
      });
  }

  next = () => {
    this.usefulSwiper.swiper.slideNext();
  }
  prev = () => {
    this.usefulSwiper.swiper.slidePrev();
  }
  closeModal = () => {
    this.dialogRef.close(this.meetingArr);
  }

  editModal = (id) => {
    this.router.navigate(['/app/dashboard/meeting/add-meeting'], { queryParams: { id: id } });
    this.dialogRef.close();
  }

  delete(id) {
    this.confirmDialog = this.dialog.open(ConfirmModalComponent, {
      autoFocus: false,
      panelClass: 'modal-xs',
      disableClose: true,
      data: { action: 'delete', title: 'Are you sure you want to delete this program?' }
    });
    this.confirmDialog.afterClosed()
      .subscribe(result => {
        if (!result) {
          return;
        } else {
          this.appService.postService({ Id: id }, 'MeetingDelete')
          .subscribe(response => {
            if (response.body.Result) {
              this.meetingList();
            }
          });
        }
      });


  }

  viewAllUser = (ln: number) => {
    this.isMoreUser = ln;
  }


}
